import { render } from "./HomeServerStatus.vue?vue&type=template&id=12258e5c&scoped=true"
import script from "./HomeServerStatus.vue?vue&type=script&lang=js"
export * from "./HomeServerStatus.vue?vue&type=script&lang=js"

import "./HomeServerStatus.vue?vue&type=style&index=0&id=12258e5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_06ebbe948ebbc1bd3ebd6c3aad4ab6ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12258e5c"]])

export default __exports__